var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.800003 9.01703C0.800003 8.81935 0.826648 8.62256 0.879219 8.43199L2.0976 4.01535C2.3608 3.06127 3.22868 2.40039 4.21839 2.40039H11.7816C12.7713 2.40039 13.6392 3.06127 13.9024 4.01535L15.1208 8.43199C15.1734 8.62256 15.2 8.81935 15.2 9.01703V12.0004C15.2 12.884 14.4837 13.6004 13.6 13.6004H2.4C1.51635 13.6004 0.800003 12.884 0.800003 12.0004V9.01703ZM3.25439 4.33446C3.37403 3.90079 3.76852 3.60039 4.21839 3.60039H11.7816C12.2315 3.60039 12.626 3.90079 12.7456 4.33446L13.964 8.7511C13.9685 8.76744 13.9726 8.78387 13.9763 8.80039H11.2C10.9177 8.80039 10.6563 8.9492 10.5121 9.19196L10.0271 10.0088C9.88297 10.2516 9.62155 10.4004 9.33922 10.4004H6.58886C6.28584 10.4004 6.00883 10.2292 5.87332 9.95816L5.51554 9.24262C5.38003 8.97159 5.10302 8.80039 4.8 8.80039H2.02375C2.02742 8.78387 2.0315 8.76744 2.03601 8.7511L3.25439 4.33446Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmIcon);
export default __webpack_public_path__ + "static/media/dm-Icon.7d28d727601a86ec96290a035c0b7e9b.svg";
export { ForwardRef as ReactComponent };